import React, { useState } from "react";
import ICONS from "./IconMap";
import "../index.css";

const Button = ({
  onClick,
  text,
  iconName,
  hidetext,
  hideicon,
  property,
  iconColor,
}) => {
  // const [isClicked, setIsClicked] = useState(false);

  const [isHover, setIsHover] = useState(false);

   const handleMouseEnter = () => {
      setIsHover(true);
   };
   const handleMouseLeave = () => {
      setIsHover(false);
   };

  // Function to determine the click style based on button color
  // const getClickColor = () => {
  //   switch (btncolor) {
  //     case "bgleads":
  //       return "rgba(58, 54, 219, 0.7)";
  //     default:
  //       return "rgba(58, 54, 219, 0.7)";
  //   }
  // };

  // const clickStyle = isClicked ? { backgroundColor: getClickColor() } : {};
  // const buttonStyle = btncolor ? styles[`button_${btncolor}`] : styles.button;
  // const buttonStyle = {
  //   ...styles.button,
  //   ...(btncolor ? styles[`button_${btncolor}`] : {}),
  //   ...clickStyle,
  // };

  const iconContainerStyle = property
    ? styles[`iconContainer_${property}`]
    : styles.iconContainer;

  const IconComponent = ICONS[iconName];

  const handleButtonClick = (e) => {
    // setIsClicked(true);
    // setTimeout(() => setIsClicked(false), 300); // Change color back after 300ms
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button style={isHover ? styles.button : styles.buttonBgChange } onClick={handleButtonClick} 
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}>
      {!hideicon && IconComponent && (
        <div style={iconContainerStyle}>
          <IconComponent color={iconColor} size={20} />
        </div>
      )}
      {!hidetext && text}
    </button>
  );
};

export default Button;

const styles = {
  button: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#3A36DB",
    color: "white",
    border: "none",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    height: "45px",
    gap: "5px",
  },
  buttonBgChange: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#4A76FD",
    color: "white",
    border: "none",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    height: "45px",
    gap: "5px",
  },
  button_popUpModel: {
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    backgroundColor: "#D2DFF9",
    color: "#06152B",
    border: "none",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    height: "45px",
    gap: "5px",
  },
  button_bgleads: {
    padding: "0px 0px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#3A36DB",
    color: "white",
    border: "none",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    margin: "0 10px 0 10px",
    height: "32px",
    width: "100%",
    gap: "5px",
  },
  button_leadstrack: {
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    backgroundColor: "#3A36DB",
    color: "white",
    border: "none",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "background-color 0.2s ease",
    height: "38px",
    gap: "5px",
  },
};
